'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appStore from './AppStore';
import Backdoor from './Backdoor';
import AppInfo from './AppInfo';

const defaultFooterLinks = [
    {url: 'https://itconnect.uw.edu/help/', text: 'Contact'},
    {url: 'http://www.washington.edu/online/privacy', text: 'Privacy'},
    {url: 'http://www.washington.edu/online/terms', text: 'Terms'}
]

const AppFooterDefault = ({links = defaultFooterLinks}) => {
    let backdoor = (appStore.isAuthenticated() && appStore.isBackdoorAllowed()) ? <li className="list-inline-item mb-2 mb-md-0"><Backdoor /></li> : null;

    let footerLinks
    if (links.length > 0) {
        let footerLinksList = links.map((link, index) => {
            return (
                <li className="list-inline-item mb-2 mb-md-0" key={index}><a href={link.url}
                                                                             target="_blank">{link.text}</a></li>
            );
        });

        footerLinks =
            <div className="text-center text-md-start">
                <ul className="list-inline list-inline-pipe-separated">
                    {footerLinksList}
                </ul>
            </div>
    }

    return (
        <footer className="app-footer d-print-none fs-7 py-4" role="contentinfo">
            <div className="container-xxl d-md-flex align-items-md-start justify-content-md-between">
                {footerLinks}
                <div className="text-center text-md-end mt-4 mt-md-0">
                    <ul className="list-inline list-inline-pipe-separated">
                        <li className="list-inline-item mb-2 mb-md-0">&copy; {new Date().getFullYear()} <a href="https://www.washington.edu/" target="_blank">University of Washington</a></li>
                        <li className="list-inline-item mb-2 mb-md-0">Seattle, WA</li>
                    </ul>
                    <ul className="list-inline list-inline-pipe-separated mt-3">
                        <li className="list-inline-item mb-2 mb-md-0"><AppInfo /></li>
                        {backdoor}
                    </ul>
                </div>
            </div>
        </footer>
    );
};

AppFooterDefault.propTypes = {
    links: PropTypes.array
}

export default AppFooterDefault;
